import {
  TE8MasterName,
  TRESPONSE_BUNDLE_ALLOWANCE_MASTER,
  TRESPONSE_FATIGUE_ALLOWANCE_MASTER,
  TRESPONSE_GET_ALL_PRODUCT_TYPE_OPTIONS,
  TRESPONSE_MACHINE_MASTER,
  TRESPONSE_OPERATION_MASTER,
  TRESPONSE_PART_MASTER,
  TRESPONSE_PRODUCT_TYPE_MASTER,
  TRESPONSE_STYLE_MASTER,
} from '@monorepo/types';
import { FETCH_LIBRARY_METHODS_MOCK } from './fetch-library-methods.mock';

export type TE8MasterMockItem = {
  id: string;
  code: string;
  title: string;
  subtitle: string;
  productType?: string;
  allowanceValue?: string;
};

const common = {
  paginationInfo: FETCH_LIBRARY_METHODS_MOCK.paginationInfo,
  filters: FETCH_LIBRARY_METHODS_MOCK.filters,
  sortingOptions: [
    { displayName: 'Line-Increasing', sortingKey: 'LINE', sortingOrder: 'ASCENDING' as const },
    { displayName: 'Line-Decreasing', sortingKey: 'LINE', sortingOrder: 'DESCENDING' as const },
    { displayName: 'Section-Increasing', sortingKey: 'SECTION', sortingOrder: 'ASCENDING' as const },
    { displayName: 'Section-Decreasing', sortingKey: 'SECTION', sortingOrder: 'DESCENDING' as const },
  ],
};

// TODO: no listing endpoint exists yet for masters (Engineeri8DataService only has
// ADD_NEW_*_MASTER writes) — stand-in data so masters-container's tab/page/search
// wiring is real; swap for a real Engineeri8DataService list call once that API exists.
export const MOCK_ITEMS_BY_TAB: Record<Exclude<TE8MasterName, 'FATIGUE_ALLOWANCE'>, TE8MasterMockItem[]> = {
  PRODUCT_TYPE: [
    { id: 'PT01_id', code: 'PT01', title: 'Shirt', subtitle: '100% Cotton, Regular Fit' },
    { id: 'PT02_id', code: 'PT02', title: 'Chino Trousers', subtitle: 'Stretch Cotton Blend' },
    { id: 'PT03_id', code: 'PT03', title: 'Bomber Jacket', subtitle: 'Polyester Shell, Nylon Liner' },
    { id: 'PT04_id', code: 'PT04', title: 'Polo T-Shirt', subtitle: 'Pique Cotton, Slim Fit' },
    { id: 'PT05_id', code: 'PT05', title: 'Cargo Shorts', subtitle: 'Ripstop Fabric, 6-pocket' },
    { id: 'PT06_id', code: 'PT06', title: 'Denim Jeans', subtitle: '98% Cotton, 2% Elastane' },
    { id: 'PT07_id', code: 'PT07', title: 'Linen Kurta', subtitle: 'Pure Linen, Relaxed Fit' },
    { id: 'PT08_id', code: 'PT08', title: 'Fleece Hoodie', subtitle: 'Anti-pill Polar Fleece' },
    { id: 'PT09_id', code: 'PT09', title: 'Formal Blazer', subtitle: 'Wool Blend, Structured' },
  ],
  OPERATION: [
    { id: 'OP01', code: 'OP01', productType: 'Shirt', title: 'Collar Attach', subtitle: 'Run Stitch on Collar Edge' },
    { id: 'OP02', code: 'OP02', productType: 'Shirt', title: 'Attach Pocket', subtitle: 'Attach Front Patch Pocket' },
    { id: 'OP03', code: 'OP03', productType: 'Shirt', title: 'Sleeve Attach', subtitle: 'Attach sleeve to arm hole' },
    { id: 'OP04', code: 'OP04', productType: 'Shirt', title: 'Sleeve Hemming', subtitle: 'Lorem Ipsum Description' },
    { id: 'OP05', code: 'OP05', productType: 'Shirt', title: 'Side Seam Join', subtitle: 'Lorem Ipsum Description' },
    { id: 'OP06', code: 'OP06', productType: 'Shirt', title: 'Shoulder Join', subtitle: 'Lorem Ipsum Description' },
    { id: 'OP07', code: 'OP07', productType: 'Shirt', title: 'Placket Attach', subtitle: 'Lorem Ipsum Description' },
    { id: 'OP08', code: 'OP08', productType: 'Shirt', title: 'Cuff Attach', subtitle: 'Lorem Ipsum Description' },
    { id: 'OP09', code: 'OP09', productType: 'T-shirt', title: 'Collar Attach', subtitle: 'Lorem Ipsum Description' },
  ],
  PART: [
    { id: 'PR01', code: 'PR01', productType: 'Shirt', title: 'Front Panel', subtitle: 'Lorem Ipsum Description' },
    { id: 'PR02', code: 'PR02', productType: 'Shirt', title: 'Pocket', subtitle: 'Lorem Ipsum Description' },
    { id: 'PR03', code: 'PR03', productType: 'Shirt', title: 'Back Panel', subtitle: 'Lorem Ipsum Description' },
    { id: 'PR04', code: 'PR04', productType: 'Shirt', title: 'Inseam', subtitle: 'Lorem Ipsum Description' },
    { id: 'PR05', code: 'PR05', productType: 'Shirt', title: 'Side Seam', subtitle: 'Lorem Ipsum Description' },
    { id: 'PR06', code: 'PR06', productType: 'Shirt', title: 'Croach', subtitle: 'Lorem Ipsum Description' },
    { id: 'PR07', code: 'PR07', productType: 'Shirt', title: 'Croach 2', subtitle: 'Lorem Ipsum Description' },
    { id: 'PR08', code: 'PR08', productType: 'Shirt', title: 'Croach 3', subtitle: 'Lorem Ipsum Description' },
    { id: 'PR09', code: 'PR09', productType: 'T-shirt', title: 'Front Panel', subtitle: 'Lorem Ipsum Description' },
  ],
  MACHINE: [
    {
      id: 'MC01',
      code: 'MC01',
      allowanceValue: '1.2',
      title: 'Single Needle Lock Stitch',
      subtitle: 'Lorem Ipsum Description',
    },
    {
      id: 'MC02',
      code: 'MC02',
      allowanceValue: '1.2',
      title: 'Double Needle Lock Stitch',
      subtitle: 'Lorem Ipsum Description',
    },
    {
      id: 'MC03',
      code: 'MC03',
      allowanceValue: '1.2',
      title: 'Multi needle Chain Stitch',
      subtitle: 'Lorem Ipsum Description',
    },
    {
      id: 'MC04',
      code: 'MC04',
      allowanceValue: '1.2',
      title: 'Chain Stitch Machine',
      subtitle: 'Lorem Ipsum Description',
    },
    { id: 'MC05', code: 'MC05', allowanceValue: '1.2', title: 'Manual Handling', subtitle: 'Lorem Ipsum Description' },
    { id: 'MC06', code: 'MC06', allowanceValue: '1.2', title: 'Bottom Hemming', subtitle: 'Lorem Ipsum Description' },
    { id: 'MC07', code: 'MC07', allowanceValue: '1.2', title: 'Bottom Hemming 2', subtitle: 'Lorem Ipsum Description' },
    { id: 'MC08', code: 'MC08', allowanceValue: '1.2', title: 'Bottom Hemming 3', subtitle: 'Lorem Ipsum Description' },
    { id: 'MC09', code: 'MC09', allowanceValue: '1.2', title: 'Bottom Hemming 4', subtitle: 'Lorem Ipsum Description' },
  ],
  STYLE_NO: [
    { id: 'ST01', code: 'ST01', productType: 'Shirt', title: 'ADS-2024-S01', subtitle: 'Lorem Ipsum Description' },
    { id: 'ST02', code: 'ST02', productType: 'Shirt', title: 'ADS-STRIPE-01', subtitle: 'Lorem Ipsum Description' },
    { id: 'ST03', code: 'ST03', productType: 'Shirt', title: 'ZRA-POLO-01', subtitle: 'Lorem Ipsum Description' },
    { id: 'ST04', code: 'ST04', productType: 'Shirt', title: 'ADS-2024-S01', subtitle: 'Lorem Ipsum Description' },
    { id: 'ST05', code: 'ST05', productType: 'Shirt', title: 'ADS-STRIPE-01', subtitle: 'Lorem Ipsum Description' },
    { id: 'ST06', code: 'ST06', productType: 'Shirt', title: 'ZRA-POLO-01', subtitle: 'Lorem Ipsum Description' },
    { id: 'ST07', code: 'ST07', productType: 'Shirt', title: 'ZRA-POLO-02', subtitle: 'Lorem Ipsum Description' },
    { id: 'ST08', code: 'ST08', productType: 'Shirt', title: 'ZRA-POLO-03', subtitle: 'Lorem Ipsum Description' },
    { id: 'ST09', code: 'ST09', productType: 'Shirt', title: 'ZRA-POLO-04', subtitle: 'Lorem Ipsum Description' },
  ],
};

export const MOCK_PRODUCT_TYPE_MASTERS: TRESPONSE_PRODUCT_TYPE_MASTER = {
  data: MOCK_ITEMS_BY_TAB.PRODUCT_TYPE.map((item) => ({
    id: item.id,
    code: item.code,
    name: item.title,
    description: item.subtitle,
    inUse: false,
  })),
  ...common,
};

export const MOCK_GET_ALL_PRODUCT_TYPE_OPTIONS: TRESPONSE_GET_ALL_PRODUCT_TYPE_OPTIONS = {
  data: MOCK_ITEMS_BY_TAB.PRODUCT_TYPE.map((item) => ({
    id: item.id,
    code: item.code,
    name: item.title,
  })),
};

export const MOCK_OPERATION_MASTERS: TRESPONSE_OPERATION_MASTER = {
  ...common,
  data: MOCK_ITEMS_BY_TAB.OPERATION.map((item) => ({
    id: item.id,
    code: item.code,
    name: item.title,
    description: item.subtitle,
    productTypeId: item.productType ?? '',
    productTypeName: item.productType ?? '',
    inUse: true,
  })),
};

export const MOCK_PART_MASTERS: TRESPONSE_PART_MASTER = {
  ...common,
  data: MOCK_ITEMS_BY_TAB.PART.map((item) => ({
    id: item.id,
    code: item.code,
    name: item.title,
    description: item.subtitle,
    productTypeId: item.productType ?? '',
    productTypeName: item.productType ?? '',
    inUse: true,
  })),
};

export const MOCK_STYLE_MASTERS: TRESPONSE_STYLE_MASTER = {
  ...common,
  data: MOCK_ITEMS_BY_TAB.STYLE_NO.map((item) => ({
    id: item.id,
    code: item.code,
    styleNo: item.title,
    description: item.subtitle,
    productTypeId: item.productType ?? '',
    productTypeName: item.productType ?? '',
    inUse: false,
  })),
};

export const MOCK_MACHINE_MASTERS: TRESPONSE_MACHINE_MASTER = {
  ...common,
  data: MOCK_ITEMS_BY_TAB.MACHINE.map((item) => ({
    id: item.id,
    code: item.code,
    name: item.title,
    allowancePercent: Number(item.allowanceValue ?? 0),
    description: item.subtitle,
    inUse: true,
  })),
};

export const BUNDLE_ALLOWANCE_MOCK: TRESPONSE_BUNDLE_ALLOWANCE_MASTER = {
  data: { id: 'ba_1', valuePercent: 3, version: 0 },
};

export const FATIGUE_ALLOWANCE_MOCKS: TRESPONSE_FATIGUE_ALLOWANCE_MASTER = {
  data: [
    { id: 'fa_1', name: 'Standing', valuePercent: 0.01, version: 0 },
    { id: 'fa_2', name: 'Sitting', valuePercent: 0.11, version: 0 },
    { id: 'fa_3', name: 'Bending', valuePercent: 0.16, version: 0 },
    { id: 'fa_4', name: 'Repetition of Work', valuePercent: 1.05, version: 0 },
    { id: 'fa_5', name: 'Concentration Required', valuePercent: 2.1, version: 0 },
  ],
  ...common,
};
